module.exports = __webpack_public_path__ + "img/Healtech_heart.ecc81f6b.svg";